<template>
    <div class="dialogView">
        <div class="dialog_header">
            <div class="hd_left">
                <i class="iconfont iconfont guoran-liebiao1"></i>
            </div>
            <div class="hd_middle">
                <div class="botIcon">
                    <i class="iconfont guoran-tongyichicun-write-29-jiqiren2"></i>
                </div>
                <span class="name" v-if="agentBindBotInfos.length > 0">
                    {{ agentBindBotInfos[0].agentName }}
                </span>
                <i class="el-icon-arrow-down" v-if="bindDetail.selectAgent"></i>
            </div>
            <div class="hd_right">
                <i class="iconfont guoran-xinjianhuihua"></i>
            </div>
        </div>
        <div class="dialog_content">

        </div>
        <div class="dialog_footer">
            <div class="fast_select_list" v-if="shortcutBtnType == 0">
                <div class="fast_select_item" v-for="(item, index) in fastSelectList" :key="index">
                    <!-- <div class="shortcut_btn_item_left">
                        <i class="iconfont guoran-a-16-10"></i>
                    </div>
                    <div class="fast_select_item_title">
                        {{ item.title }}
                    </div> -->
                    <div class="shortcut-select-cell-item">
                        <div class="shortcut_btn_icon">
                            <!-- <img :src="shortcut.icon" alt="" /> -->
                            <svgOrIcon :icon="item.icon" iconClass="iconfont"></svgOrIcon>
                        </div>
                        <div class="shortcut_btn_text">{{ item.name }}</div>
                    </div>
                </div>
            </div>
            <div class="fast_select_list" v-if="shortcutBtnType == 1 && agentBindBotInfos.length > 0">
                <div class="fast_select_item" v-for="(item, index) in agentBindBotInfos[0].shortcutBtnList" :key="index">
                    <!-- <div class="shortcut_btn_item_left">
                        <i class="iconfont guoran-a-16-10"></i>
                    </div>
                    <div class="fast_select_item_title">
                        {{ item.title }}
                    </div> -->
                    <div class="shortcut-select-cell-item">
                        <div class="shortcut_btn_icon">
                            <!-- <img :src="shortcut.icon" alt="" /> -->
                            <svgOrIcon :icon="item.icon" iconClass="iconfont"></svgOrIcon>
                        </div>
                        <div class="shortcut_btn_text">{{ item.name }}</div>
                    </div>
                </div>
            </div>
            <div class="fast_select_list" v-if="shortcutBtnType == 2 && groupList.length > 0">
                <div class="fast_select_item" v-for="(item, index) in groupList[0].shortcutBtnList" :key="index">
                    <div class="shortcut-select-cell-item">
                        <div class="shortcut_btn_icon">
                            <svgOrIcon :icon="item.icon" iconClass="iconfont"></svgOrIcon>
                        </div>
                        <div class="shortcut_btn_text">{{ item.name }}</div>
                    </div>
                </div>
            </div>
            <div class="footer_content">
                <div class="footer_input">
                    <el-input :placeholder="'请输入'" size="medium">
                    </el-input>
                    <div class="footer_btn">
                        <i class="iconfont guoran-wenjianjia240720" v-if="detail.allowFileUpload"></i>
                        <i class="iconfont guoran-tongyichicun-tupian2" v-if="detail.allowImageUpload"></i>
                        <span class="send">
                            <i class="arsenal_icon arsenalfasong"></i>
                        </span>
                    </div>
                </div>

                <div class="footer_function">
                    <div class="model_btn" v-if="detail.enableAgentSelect">
                        <img src="https://static.guoranbot.com/cdn-lightning-bot/dev/img/AskAILogo4.7fbba064.png"
                            alt="">
                        DeepSeek
                        <span class="model-active-mode-down el-icon-arrow-down"></span>
                    </div>

                    <div class="model_btn" v-if="detail.enableAgentConfig">
                        <i class="iconfont guoran-tongyichicun-chanpinguanli"></i>
                        能力管理
                        <div class="popover_content" >
                            <div class="popover_item" v-if="agentConfig.noAIGeAbliWarning">
                                <div class="online-search-switch">
                                    <el-switch :width="42" :disabled="!intelligentAgentDetail.aiGeneration"
                                        v-model="aiGeneration" active-color="#366AFF" inactive-color="#E2E2E2">
                                        >
                                    </el-switch>
                                    <span class="switch-open-icon" v-if="aiGeneration"><i
                                            class="iconfont guoran-a-16-17"></i></span>
                                    <span class="switch-close-icon" v-if="!aiGeneration"><i
                                            class="arsenal_icon arsenalcuo1"></i></span>
                                </div>
                                <div class="item-title">
                                    大模型生成
                                </div>
                            </div>
                            <div class="popover_item" v-if="agentConfig.noPluginSearchAbliWarning">
                                <div class="online-search-switch">
                                    <el-switch :width="42" :disabled="!intelligentAgentDetail.usePlugin"
                                        v-model="usePlugin" active-color="#366AFF" inactive-color="#E2E2E2">
                                        >
                                    </el-switch>
                                    <span class="switch-open-icon" v-if="usePlugin"><i
                                            class="iconfont guoran-a-16-17"></i></span>
                                    <span class="switch-close-icon" v-if="!usePlugin"><i
                                            class="arsenal_icon arsenalcuo1"></i></span>
                                </div>
                                <div class="item-title">
                                    工具调用
                                </div>
                            </div>
                            <div class="popover_item" v-if="agentConfig.noKnowSearchAbliWarning">
                                <div class="online-search-switch">
                                    <el-switch :width="42" :disabled="!intelligentAgentDetail.knowledgeSearch"
                                        v-model="knowledgeSearch" active-color="#366AFF" inactive-color="#E2E2E2">
                                        >
                                    </el-switch>
                                    <span class="switch-open-icon" v-if="knowledgeSearch"><i
                                            class="iconfont guoran-a-16-17"></i></span>
                                    <span class="switch-close-icon" v-if="!knowledgeSearch"><i
                                            class="arsenal_icon arsenalcuo1"></i></span>
                                </div>
                                <div class="item-title">
                                    知识搜索
                                </div>
                            </div>
                            <div class="popover_item" v-if="intelligentAgentDetail.onlineSearch">
                                <div class="online-search-switch" >
                                    <el-switch :width="42"
                                        v-model="onlineSearch" active-color="#366AFF" inactive-color="#E2E2E2">
                                        >
                                    </el-switch>
                                    <span class="switch-open-icon" v-if="onlineSearch"><i
                                            class="iconfont guoran-a-16-17"></i></span>
                                    <span class="switch-close-icon" v-if="!onlineSearch"><i
                                            class="arsenal_icon arsenalcuo1"></i></span>
                                </div>
                                <div class="item-title">
                                    联网搜索
                                </div>
                            </div>
                            <div class="popover_item" v-if="intelligentAgentDetail.enableDeepSeek && intelligentAgentDetail.deepSeekModelId">
                                <div class="online-search-switch">
                                    <el-switch :width="42"
                                        v-model="enableDeepSeek" active-color="#366AFF" inactive-color="#E2E2E2">
                                        >
                                    </el-switch>
                                    <span class="switch-open-icon" v-if="enableDeepSeek"><i
                                            class="iconfont guoran-a-16-17"></i></span>
                                    <span class="switch-close-icon" v-if="!enableDeepSeek"><i
                                            class="arsenal_icon arsenalcuo1"></i></span>
                                </div>
                                <div class="item-title">
                                    深度思考
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="model_btn" v-if="detail.exampleQuestionEnable">
                        <i class="iconfont  guoran-tongyichicun-huanyingyu"></i>
                        示例
                    </div>


                </div>
            </div>

        </div>
    </div>
</template>

<script>
import svgOrIcon from '../../../components/svgOrIcon.vue'
export default {
    props: {
        bindDetail: {
            type: Object,
            default: () => ({})
        },
        intelligentAgentDetail: {
            type: Object,
            default: () => ({})
        },
        fastSelectList: {
            type: Array,
            default: () => []
        },
        agentBindBotInfos: {
            type: Array,
            default: () => []
        },
        shortcutBtnType: {
            type: Number,
            default: 0
        },
        groupList: {
            type: Array,
            default: () => []
        },
        agentConfig: {
            type: Object,
            default: () => ({
                noAIGeAbliWarning: false,
                noPluginSearchAbliWarning: false,
                noKnowSearchAbliWarning: false,
            })
        }
    },
    components: {
        svgOrIcon
    },
    data() {
        return {
            agentConfigList: [
                { title: '大模型生成', value: true, id: 'aiGeneration' },
                { title: '工具调用', value: true, id: 'usePlugin' },
                { title: '知识搜索', value: true, id: 'knowledgeSearch' },
                { title: '联网搜索', value: true, id: 'onlineSearch' },
                { title: '深度思考', value: true, id: 'enableDeepSeek' },
            ],
            aiGeneration: true,
            usePlugin: true,
            knowledgeSearch: true,
            onlineSearch: true,
            enableDeepSeek: true,
        }
    },
    computed: {
        detail() {
            return JSON.parse(JSON.stringify(this.intelligentAgentDetail))
        },
        visible() {
            if (this.detail.enableAgentConfig) {
                return true
            } else {
                return false
            }
        }
    },
    mounted() {
        // this.visible = true
    },
    methods: {
        changeEnableAgentConfig(type) {
            if (type === 'switch') {
                this.visible = !this.visible
            } else if (type === 'open') {
                this.visible = false
            } else if (type === 'close') {
                this.visible = true
            }
        }
    },
    watch: {
        intelligentAgentDetail: {
            handler(newVal, oldVal) {
                if(newVal) {
                    if(!this.intelligentAgentDetail.aiGeneration) {
                        this.aiGeneration = true
                    }
                    if(!this.intelligentAgentDetail.usePlugin) {
                        this.usePlugin = true
                    }
                    if(!this.intelligentAgentDetail.knowledgeSearch) {
                        this.knowledgeSearch = true
                    }
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="less" scoped>
.dialogView {
    width: 100%;
    height: 100%;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;
    background-color: #F5F7FB;

    border-radius: 4px;

    .dialog_header {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        font-size: 14px;
        box-sizing: border-box;
        padding: 0 6px;

        i {
            color: #909399;
        }

        .hd_left,
        .hd_right {
            width: 24px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .hd_middle {
            flex: none;
            display: flex;
            align-items: center;
            cursor: pointer;

            .botIcon {
                flex: none;
                width: 20px;
                height: 20px;
                background: #7596f5;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 6px;

                i {
                    font-size: 14px;
                    color: #ffffff;
                }

                img {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    overflow: hidden;
                    object-fit: cover;
                }
            }

            .name {
                flex: auto;
                font-size: 15px;
                color: #000000;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                /* 控制显示的行数 */
                -webkit-box-orient: vertical;
            }

            .guoran-tongyichicun-qiehuan {
                margin-left: 6px;
                color: #366aff;
                font-size: 14px;
            }

            .el-icon-arrow-down,
            .el-icon-arrow-up {
                flex: none;
                margin-left: 6px;
                border-radius: 50%;
                width: 20px;
                height: 20px;
                background: #F8FAFC;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #366AFF;
            }
        }
    }

    .dialog_footer {
        height: auto;
        width: 100%;
        box-sizing: border-box;
        padding: 6px;

        .fast_select_list {
            // width: 100%;
            // height: ;
            display: flex;
            align-items: center;
            overflow: hidden;
            overflow-x: auto;
            margin-bottom: 8px;

            .fast_select_item {
                height: 12px;
                line-height: 12px;
                background-color: white;
                border-radius: 4px;
                padding: 6px;
                display: flex;
                align-items: center;
                font-size: 14px;
                margin-right: 8px;
                cursor: pointer;
                flex: none;
                .shortcut-select-cell-item {
                    display: flex;
                    align-items: center;
                    
                    .shortcut_btn_icon {
                        margin-right: 8px;
                    }
                }
            }
        }

        .fast_select_list::-webkit-scrollbar {
            height: 6px;
        }

        .footer_content {
            width: 100%;
            height: auto;
            border-radius: 12px;
            background-color: #FFFFFF;
            padding: 8px;
            box-sizing: border-box;
            // display: flex;
            // align-items: center;
            // justify-content: space-between;

            .footer_input {
                width: 100%;
                height: 28px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .el-input {
                    height: auto;
                    /* margin: 0 10px 0 !important;*/

                    /deep/.el-input__inner {
                        // height: 38px !important;
                        width: 100%;
                        border: none;
                        background: transparent;
                        padding: 0;
                    }

                    /deep/.el-input__inner:focus {
                        border: none;
                        box-shadow: none;
                    }
                }

                .footer_btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    i {
                        color: #747fa1;
                        font-size: 16px;
                        margin-right: 8px;
                    }

                    .send {
                        width: 22px;
                        height: 22px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: #366AFF;
                        border-radius: 24px;
                        cursor: pointer;

                        i {
                            font-size: 14px;
                            color: #FFFFFF;
                            margin-right: 0;
                            margin-left: 1px;
                        }
                    }
                }
            }

            .footer_function {
                width: 100%;
                height: auto;
                display: flex;
                align-items: center;

                .model_btn {
                    flex: none;
                    text-align: center;
                    background-color: #eef2ff;
                    border-radius: 24px;
                    cursor: pointer;
                    padding: 2px 6px;
                    box-sizing: border-box;
                    font-size: 12px;
                    display: flex;
                    align-items: center;
                    margin-right: 6px;
                    position: relative;
                    margin-top: 8px;

                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 4px;
                    }

                    .model-active-mode-down {
                        margin-left: 4px;
                        font-size: 12px;
                        color: #a4b2cf;
                    }

                    i {
                        color: #6e6b7b;
                        font-size: 14px;
                        margin-right: 4px;
                    }
                }
            }

        }
    }

    .popover_content {
        width: 160px;
        height: auto;
        background-color: #FFFFFF;
        box-sizing: border-box;
        position: absolute;
        left: 10px;
        bottom: 30px;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;
        border-radius: 4px;

        .popover_item {
            display: flex;
            align-items: center;
            padding: 6px 12px;
            cursor: pointer;

            .item-title {
                margin-left: 12px;
                margin-right: 8px;
                font-size: 14px;

                .item-title-warnning {
                    display: inline-block;
                    border-radius: 5px;
                    padding: 0 5px;
                    font-size: 12px;
                    color: red;
                    background-color: rgb(254, 240, 240);
                }
            }


            .online-search-switch {
                display: flex;
                flex-direction: row;
                height: 25px;
                justify-content: space-between;
                cursor: pointer;
                position: relative;
                text-align: center;
                align-items: center;

                .el-switch {
                    text-align: center;
                }

                .switch-open-icon {
                    position: absolute;
                    z-index: 9999;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 3px;

                    i {
                        color: white;
                        font-size: 16px;
                    }
                }

                .switch-close-icon {
                    position: absolute;
                    z-index: 9999;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 21px;

                    i {
                        color: #6e6b7b;
                        font-size: 14px;
                        font-weight: 600;
                    }
                }

                i {
                    color: #366aff;
                    font-size: 18px;
                }

                .el-switch__core::after {
                    width: 14px;
                    height: 14px;
                    top: 2px;
                    left: 2px;
                }

                .is-checked .el-switch__core::after {
                    left: 40px;
                }

                &.disabled {

                    i,
                    .el-switch__input,
                    .el-switch__core {
                        cursor: no-drop;
                    }
                }
            }
        }

        // .popover_item:last-child {
        //     padding: 3px 12px;
        // }
        .popover_item:hover {
            background-color: #F5F7FB;
        }
    }

}
</style>
<style lang="less">
.dialog_popover_content {
    width: 160px !important;
    padding: 6px 0 !important;

}
</style>
